import { useEffect, useState } from "react";
import styled from "styled-components";
import { DisplayType } from "../../constants/ui";
import Map from "../map";
import GymList from "./gymList";
import SearchForm from "./search/searchForm";
import Gym from "@puregym/acquisition-models/gym";
import useFlagshipFlag from "../../utilities/experiments/useFlagshipFlag";
import ExperimentGymList from "../experiments/experimentGymList";
import ExperimentSearchForm from "../experiments/experimentSearchForm";

const PrimaryPanelWrapper = styled.section`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.background};
`;

const PrimaryPanel = ({
  defaultGymDisplayType,
  gyms,
}: {
  defaultGymDisplayType: DisplayType;
  gyms: Gym[];
}) => {
  const [gymDisplayType, setGymDisplayType] = useState<DisplayType>(
    defaultGymDisplayType
  );

  const { isExperiment: isDisplayTypeExperiment } = useFlagshipFlag({
    experimentFlag: "list_view",
    debugLog: true,
  });

  const { isExperiment: isSearchFormExperiment } = useFlagshipFlag({
    experimentFlag: "search_text",
    debugLog: true,
  });

  useEffect(
    () => setGymDisplayType(isDisplayTypeExperiment ? "list" : defaultGymDisplayType),
    [defaultGymDisplayType, isDisplayTypeExperiment]
  );

  return (
    <PrimaryPanelWrapper>
      {(isSearchFormExperiment
          ? <ExperimentSearchForm
              displayType={gymDisplayType}
              toggleDisplayType={setGymDisplayType}
            />
          : <SearchForm
              displayType={gymDisplayType}
              toggleDisplayType={setGymDisplayType}
            />)}
      {gymDisplayType === "map" ? (
        <Map gyms={gyms} testid="gymMap" />
      ) : (
        isSearchFormExperiment
          ? <ExperimentGymList /> 
          : <GymList />
      )}
      {/* <InfoModal isOpen={modalOpen} setIsOpen={setModalOpen} /> */}
    </PrimaryPanelWrapper>
  );
};

export default PrimaryPanel;
